import arrowRightBlue from '../../../../assets/icons/arrow-right-blue.svg';
import outlineRepeat from '../../../../assets/icons/outline_repeat.svg';

declare function Translate(key: string): string;
declare var _loginMethodSmsOtpUrl: any;

const BackLink = (props) => {
    const onBackHandler = () => {
        props.back();
    }

    const onBackPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13 || event.charCode === 32){
            onBackHandler();
        }
    };

    return (
        <div className='d-flex align-items-center goBackButton'>
            {props.loginType !== "Loa4Landing" && 
                <img src={arrowRightBlue} alt="" id='goBackImg' aria-hidden="true" className='goBackImg' onClick={onBackHandler}/>
            }
            {props.loginType === "Loa4Landing" && 
                <img src={outlineRepeat}  id='goBackImg' aria-hidden="true" alt="" className='goBackImg' onClick={onBackHandler}/>
            }
            <span aria-hidden="true">&nbsp;&nbsp;</span>                        
            <a id='goBackLink' 
                className='goBackLink' 
                onClick={onBackHandler}
                onKeyPress={onBackPress}
                tabIndex={0}
            >
                {props.translate}
            </a>
        </div>         
    );
}

export default BackLink;